import { render, staticRenderFns } from "./ProjectViewAlarmAreas.vue?vue&type=template&id=47a6a475&scoped=true&"
import script from "./ProjectViewAlarmAreas.vue?vue&type=script&lang=js&"
export * from "./ProjectViewAlarmAreas.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewAlarmAreas.vue?vue&type=style&index=0&id=47a6a475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6a475",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
